var map = {
	"./assignment.png": 3729,
	"./collection.png": 4531,
	"./exam.png": 1685,
	"./lecture.png": 1270,
	"./note.png": 8752,
	"./other.png": 1112,
	"./project.png": 53,
	"./slide.png": 649,
	"./video.png": 267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7035;